import MiTooltip from './MiTooltip.vue'

export default MiTooltip
